import { styled } from 'styles';
import { CardContentProps } from './types';

export const CardContent = styled.div<CardContentProps>`
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.absolute.larger}
    ${({ spaced = true, theme }) => (spaced ? theme.spacing.absolute.larger : 0)};
  position: relative;
`;

export const StyledCard = styled.div`
  background-color: ${({ theme }) => theme.card.background};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.shadow.medium};
  overflow: hidden;
  width: 100%;

  @media (max-width: 992px) {
    box-shadow: ${({ theme }) => theme.shadow.small};
  }
`;

CardContent.displayName = 'CardContent';
StyledCard.displayName = 'Card';
